import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {uiActions} from '../chrome/';

import './Popup.css';

class Popup extends Component {
	constructor(props) {
		super(props);

		const show = !localStorage.getItem(`${props.className}Popup`);
		this.state = {
			show: show,
			history: 0,
			visible:
				show && props.minPages === 0 && (props.popup === null || props.popup === props.className)
		};
	}

	componentDidMount() {
		this.unlisten = this.props.history.listen((location, action) => {
			this.setState(prevState => ({history: prevState.history + 1}));
		});
	}
	componentDidUpdate() {
		if (
			this.state.show &&
			this.state.history >= this.props.minPages &&
			(this.props.popup === null || this.props.popup === this.props.className) &&
			!this.state.visible // stop repeat setState calls
		) {
			this.setState({visible: true});
		}
	}
	componentWillUnmount() {
		this.unlisten();
	}

	closePopup = () => {
		localStorage.setItem(`${this.props.className}Popup`, false);
		this.props.setPopup(null);
		this.setState({show: false, visible: false});
	};

	render() {
		const {className, children, minPages = 3} = this.props;
		const {visible} = this.state;

		return (
			<div className={`Popup ${className} ${visible ? '' : 'hidden'}`}>
				<button className="PopupClose" onClick={this.closePopup}>
					<span className="icon icon-close" />
				</button>
				<section className="PopupBody">{children}</section>
			</div>
		);
	}
}

export default withRouter(
	connect(
		({ui}) => ({
			popup: ui.popup
		}),
		dispatch => ({
			setPopup: popup => dispatch(uiActions.uiPopup(popup))
		})
	)(Popup)
);



// WEBPACK FOOTER //
// ./src/popups/Popup.js